import script from "./PurchasePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasePage.vue?vue&type=script&setup=true&lang=js"

import "./PurchasePage.vue?vue&type=style&index=0&id=97a4df1a&lang=scss&setup=true"

const __exports__ = script;

export default __exports__